import { createReducer, on } from '@ngrx/store';
import { getAllSuccess } from './todo.actions';
import { Todo } from '../../models/todo';

export interface TodoState {
  todoList: Todo[];
}

export const initialState: TodoState = { todoList: [] as Todo[] };

export const todoReducer = createReducer(
  initialState,
  on(getAllSuccess, (state, { todoList }) => ({
    ...state,
    todoList
  })),
);